import lumiImg from "../assets/img/lumi.png";
import mikoImg from "../assets/img/miko.png";
import riffImg from "../assets/img/riff.png";
import worldMapImg from "../assets/img/world_map.jpg";
import heroBg from "../assets/img/hero_bg.jpg";

export const IMAGES = { lumiImg, mikoImg, riffImg, worldMapImg, heroBg };

export const MASCOTS = {
  lumi: {
    id: "lumi", name: "Lumi", role: "The Singer", color: "#FF2A7A", img: lumiImg,
    blurb: "Warm & calm. Helps you feel confident.",
    welcome: ["Ready to shine? Let's go!", "You've got this. One step at a time."],
    correct: ["Beautiful!", "That was faster!", "You nailed it!", "Lovely recall!"],
    wrong: ["No worries — try again.", "Mistakes help us learn.", "Take your time."],
    milestone: ["A new fact is glowing bright!", "You're truly shining now!"],
  },
  miko: {
    id: "miko", name: "Miko", role: "The Dancer", color: "#00E5FF", img: mikoImg,
    blurb: "All about speed, streaks & flow.",
    welcome: ["Feel the rhythm — let's move!", "Keep the beat, keep the streak!"],
    correct: ["Nice tempo!", "Combo building!", "Smooth!", "In the flow!"],
    wrong: ["Reset and bounce back!", "Keep the beat going.", "Shake it off!"],
    milestone: ["Streak master!", "That flow is unstoppable!"],
  },
  riff: {
    id: "riff", name: "Riff", role: "The Rapper", color: "#FFD600", img: riffImg,
    blurb: "Clever patterns & tricky tables.",
    welcome: ["Let's break down these numbers!", "Big tables? Easy money."],
    correct: ["Clean bars!", "That's the pattern!", "Sharp!", "Big brain move!"],
    wrong: ["Regroup, we go again.", "Every miss is a lesson.", "Stay sharp."],
    milestone: ["New pattern unlocked!", "You cracked the code!"],
  },
};

export const REGIONS = [
  { id: "melody_island", name: "Melody Island", tables: [2, 3, 4, 5], world: "World 1 · Foundations",
    color: "#FF2A7A", pos: { top: "58%", left: "14%" } },
  { id: "starlight_academy", name: "Starlight Academy", tables: [6, 7, 8, 9, 10], world: "World 2 · Core Tables",
    color: "#00E5FF", pos: { top: "26%", left: "40%" } },
  { id: "dance_grove", name: "Dance Grove", tables: [11, 12, 13, 14, 15], world: "World 3 · Beyond Ten",
    color: "#00FF66", pos: { top: "62%", left: "52%" } },
  { id: "beat_studio", name: "Beat Studio", tables: [16, 17, 18, 19, 20], world: "World 4 · Master Zone",
    color: "#A855F7", pos: { top: "30%", left: "74%" } },
  { id: "puzzle_plaza", name: "Puzzle Plaza", tables: null, world: "Grand Master · 2–20 Mixed",
    color: "#FFD600", pos: { top: "70%", left: "82%" } },
];

export const GAMES = [
  { id: "target-blaster", name: "Target Blaster", tagline: "Blast the correct answer", mascot: "lumi",
    color: "#FF2A7A", icon: "Crosshair", answerStyle: "targets", stage: "targets" },
  { id: "math-racer", name: "Math Racer", tagline: "Fast recall = pure speed", mascot: "miko",
    color: "#00E5FF", icon: "Rocket", answerStyle: "pad", stage: "racer" },
  { id: "monster-battle", name: "Monster Battle", tagline: "Answers power your attacks", mascot: "riff",
    color: "#A855F7", icon: "Swords", answerStyle: "pad", stage: "monster" },
  { id: "memory-forge", name: "Memory Forge", tagline: "Match equations to products", mascot: "lumi",
    color: "#FFD600", icon: "Sparkles", component: "memory" },
  { id: "tower-builder", name: "Tower Builder", tagline: "Stack blocks, stay calm", mascot: "miko",
    color: "#00FF66", icon: "Blocks", answerStyle: "pad", stage: "tower" },
  { id: "treasure-doors", name: "Treasure Doors", tagline: "Open the right door", mascot: "riff",
    color: "#FBBF24", icon: "DoorOpen", answerStyle: "doors", stage: "doors" },
  { id: "ninja-slice", name: "Ninja Slice", tagline: "Slice the correct number", mascot: "miko",
    color: "#22D3EE", icon: "Zap", answerStyle: "orbs", stage: "ninja" },
  { id: "boss-arena", name: "Boss Arena", tagline: "Master your weak facts", mascot: "riff",
    color: "#F43F5E", icon: "Crown", answerStyle: "pad", stage: "boss", count: 15, choices: 5 },
];

export const STATE_META = {
  new: { label: "New", color: "#3B4266", symbol: "·" },
  learning: { label: "Learning", color: "#FF3366", symbol: "△" },
  developing: { label: "Developing", color: "#FBBF24", symbol: "◇" },
  fluent: { label: "Fluent", color: "#00E5FF", symbol: "◆" },
  mastered: { label: "Mastered", color: "#00FF66", symbol: "★" },
  needs_review: { label: "Needs Review", color: "#F97316", symbol: "!" },
};

export function pick(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

// ---- Cosmetic visual definitions (ids match backend catalog) ----
export const THEMES = {
  theme_aurora: {
    name: "Aurora Night",
    bg: "radial-gradient(1200px 600px at 15% -10%, rgba(255,42,122,0.22), transparent 60%), radial-gradient(1000px 700px at 100% 0%, rgba(0,229,255,0.16), transparent 55%), radial-gradient(900px 900px at 50% 120%, rgba(168,85,247,0.20), transparent 60%), linear-gradient(180deg, #0A0B1A 0%, #12091F 55%, #0A0B1A 100%)",
  },
  theme_sunset: {
    name: "Sunset Pop",
    bg: "radial-gradient(1100px 600px at 20% -10%, rgba(255,122,0,0.30), transparent 60%), radial-gradient(900px 700px at 100% 10%, rgba(255,42,122,0.24), transparent 55%), linear-gradient(180deg, #1A0A12 0%, #210E14 55%, #120609 100%)",
  },
  theme_mint: {
    name: "Mint Wave",
    bg: "radial-gradient(1100px 600px at 15% -10%, rgba(0,255,157,0.22), transparent 60%), radial-gradient(900px 700px at 100% 0%, rgba(0,229,255,0.20), transparent 55%), linear-gradient(180deg, #061A16 0%, #08211C 55%, #041210 100%)",
  },
  theme_galaxy: {
    name: "Galaxy Purple",
    bg: "radial-gradient(1100px 600px at 20% -10%, rgba(168,85,247,0.32), transparent 60%), radial-gradient(900px 700px at 100% 10%, rgba(99,102,241,0.22), transparent 55%), linear-gradient(180deg, #0C0620 0%, #140A2E 55%, #08041A 100%)",
  },
  theme_candy: {
    name: "Candy Sky",
    bg: "radial-gradient(1100px 600px at 20% -10%, rgba(255,79,216,0.30), transparent 60%), radial-gradient(900px 700px at 100% 10%, rgba(0,229,255,0.18), transparent 55%), linear-gradient(180deg, #1A0A1B 0%, #210E22 55%, #120613 100%)",
  },
};

export const TARGET_SKINS = {
  target_neon: { name: "Neon Ring", color: "#FF2A7A", radius: "9999px" },
  target_crystal: { name: "Crystal", color: "#00E5FF", radius: "14px" },
  target_star: { name: "Starburst", color: "#FFD600", radius: "28% 72% 33% 67% / 60% 30% 70% 40%" },
  target_bubble: { name: "Bubble", color: "#7CFFCB", radius: "42%" },
};

export const AURAS = {
  aura_soft: { name: "Soft Glow", glow: "rgba(255,42,122,0.55)", ring: null },
  aura_flame: { name: "Flame", glow: "rgba(255,122,0,0.75)", ring: "#FF7A00" },
  aura_ice: { name: "Ice", glow: "rgba(0,229,255,0.75)", ring: "#00E5FF" },
  aura_rainbow: { name: "Rainbow", glow: "rgba(168,85,247,0.7)", ring: "conic-gradient(#FF2A7A,#FFD600,#00FF66,#00E5FF,#A855F7,#FF2A7A)" },
};

export function auraStyle(auraId) {
  const a = AURAS[auraId] || AURAS.aura_soft;
  const style = { boxShadow: `0 0 18px ${a.glow}` };
  if (a.ring) {
    if (a.ring.startsWith("conic")) { style.borderColor = "transparent"; style.background = a.ring; }
    else style.borderColor = a.ring;
  }
  return style;
}

export function gameById(id) {
  return GAMES.find((g) => g.id === id);
}
export function regionById(id) {
  return REGIONS.find((r) => r.id === id);
}
